import styled from 'styled-components';
import { ReactComponent as RawFolderSVG } from '../../../../assets/icons/folder.svg';

export const IconFolder = styled(RawFolderSVG)`
`;
